<template>
    <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary" class="filter-project-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal">
        <div class="mt-6 flex items-center justify-between px-6">
            <h4>Filtrar proyecto</h4>
            <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
        </div>

        <vs-divider class="mb-0"></vs-divider>

        <component :is="scrollbarTag" class="scroll-area--data-list-filter-project" :settings="settings" :key="$vs.rtl">

            <div class="p-6">
                <div class="vx-row">
                    <div class="vx-col w-full md:w-1/2 mb-4">
                        <label class="text-sm font-bold opacity-100 ml-2">PROVINCIA</label>
                        <v-select :options="itemsProvincia" v-model="selectedProvincia" :clearable="false" :dir="$vs.rtl ? 'rtl' : 'ltr'" class="mb-4 md:mb-0" name="provincia">
                            <template v-slot:no-options="{ searching }">
                                <template v-if="searching">
                                    No se encontraron resultados
                                </template>
                                <span v-else style="opacity: 0.5">No existen resultados</span>
                            </template>
                        </v-select>
                        <span class="text-danger text-sm" v-show="errors.has('provincia')">{{ errors.first('provincia') }}</span>
                    </div>
                    <div class="vx-col w-full md:w-1/2 mb-4">
                        <label class="text-sm font-bold opacity-100 ml-2">DISTRITO</label>
                        <v-select :options="itemsDistrito" v-model="selectedDistrito" :clearable="false" :dir="$vs.rtl ? 'rtl' : 'ltr'" class="mb-4 md:mb-0" name="provincia">
                            <template v-slot:no-options="{ searching }">
                                <template v-if="searching">
                                    No se encontraron resultados
                                </template>
                                <span v-else style="opacity: 0.5">No existen resultados</span>
                            </template>
                        </v-select>
                        <span class="text-danger text-sm" v-show="errors.has('provincia')">{{ errors.first('provincia') }}</span>
                    </div>
                </div>

                <div class="vx-col w-full mb-4">
                    <label class="text-sm font-bold opacity-100 ml-2">Unidad Ejecutora de Inveriones (UEI)</label>
                    <v-select :options="itemsUei" v-model="selectedUei" :clearable="false" :dir="$vs.rtl ? 'rtl' : 'ltr'" class="mb-4 md:mb-0" name="estado-gestion">
                        <template v-slot:no-options="{ searching }">
                            <template v-if="searching">
                                No se encontraron resultados
                            </template>
                            <span v-else style="opacity: 0.5">No existen resultados</span>
                        </template>
                    </v-select>
                    <span class="text-danger text-sm" v-show="errors.has('estado-gestion')">{{ errors.first('estado-gestion') }}</span>
                </div>

                <div class="vx-col w-full mb-4">
                    <label class="text-sm font-bold opacity-100 ml-2">Estado Gestión</label>
                    <v-select :options="itemsGestion" v-model="selectedGestion" :clearable="false" :dir="$vs.rtl ? 'rtl' : 'ltr'" class="mb-4 md:mb-0" name="estado-gestion">
                        <template v-slot:no-options="{ searching }">
                            <template v-if="searching">
                                No se encontraron resultados
                            </template>
                            <span v-else style="opacity: 0.5">No existen resultados</span>
                        </template>
                    </v-select>
                    <span class="text-danger text-sm" v-show="errors.has('estado-gestion')">{{ errors.first('estado-gestion') }}</span>
                </div>

                <div class="vx-col w-full mb-4">
                    <label class="text-sm font-bold opacity-100 ml-2">Estado de Elaboración de Expediente</label>
                    <v-select :options="itemsElabExpediente" v-model="selectedElabExpediente" :clearable="false" :dir="$vs.rtl ? 'rtl' : 'ltr'" class="mb-4 md:mb-0" name="elab-expediente">
                        <template v-slot:no-options="{ searching }">
                            <template v-if="searching">
                                No se encontraron resultados
                            </template>
                            <span v-else style="opacity: 0.5">No existen resultados</span>
                        </template>
                    </v-select>
                    <span class="text-danger text-sm" v-show="errors.has('elab-expediente')">{{ errors.first('elab-expediente') }}</span>
                </div>

                <div class="vx-col w-full mb-2">
                    <label class="text-sm font-bold opacity-100 ml-2">Modalidad de Ejecución</label>
                    <v-select :options="itemsModalidad" v-model="selectedModalidad" :clearable="false" :dir="$vs.rtl ? 'rtl' : 'ltr'" class="mb-4 md:mb-0" name="modalidad">
                        <template v-slot:no-options="{ searching }">
                            <template v-if="searching">
                                No se encontraron resultados
                            </template>
                            <span v-else style="opacity: 0.5">No existen resultados</span>
                        </template>
                    </v-select>
                    <span class="text-danger text-sm" v-show="errors.has('modalidad')">{{ errors.first('modalidad') }}</span>
                </div>

                <div class="vx-col w-full mb-4">
                    <label class="text-sm font-bold opacity-100 ml-2">Por Administración Directa</label>
                    <v-select :options="itemsDirecta" v-model="selectedDirecta" :clearable="false" :dir="$vs.rtl ? 'rtl' : 'ltr'" class="mb-4 md:mb-0" name="estado-directa">
                        <template v-slot:no-options="{ searching }">
                            <template v-if="searching">
                                No se encontraron resultados
                            </template>
                            <span v-else style="opacity: 0.5">No existen resultados</span>
                        </template>
                    </v-select>
                    <span class="text-danger text-sm" v-show="errors.has('estado-directa')">{{ errors.first('estado-directa') }}</span>
                </div>

                <div class="vx-col w-full mb-4">
                    <label class="text-sm font-bold opacity-100 ml-2">Por Contrato</label>
                    <v-select :options="itemsContrato" v-model="selectedContrato" :clearable="false" :dir="$vs.rtl ? 'rtl' : 'ltr'" class="mb-4 md:mb-0" name="estado-contrato">
                        <template v-slot:no-options="{ searching }">
                            <template v-if="searching">
                                No se encontraron resultados
                            </template>
                            <span v-else style="opacity: 0.5">No existen resultados</span>
                        </template>
                    </v-select>
                    <span class="text-danger text-sm" v-show="errors.has('estado-contrato')">{{ errors.first('estado-contrato') }}</span>
                </div>

                <div class="vx-col w-full mb-4">
                    <label class="text-sm font-bold opacity-100 ml-2">OXI</label>
                    <v-select :options="itemsOxi" v-model="selectedOxi" :clearable="false" :dir="$vs.rtl ? 'rtl' : 'ltr'" class="mb-4 md:mb-0" name="oxi">
                        <template v-slot:no-options="{ searching }">
                            <template v-if="searching">
                                No se encontraron resultados
                            </template>
                            <span v-else style="opacity: 0.5">No existen resultados</span>
                        </template>
                    </v-select>
                    <span class="text-danger text-sm" v-show="errors.has('oxi')">{{ errors.first('oxi') }}</span>
                </div>
            </div>

        </component>

        <div class="flex flex-wrap items-center p-6" slot="footer">
            <vs-button @click="aplicar" class="ml-auto mr-2" icon-pack="feather" color="primary" icon="icon-check">Aplicar</vs-button>
            <vs-button @click="limpiar" icon-pack="feather" color="warning" type="border" icon="icon-trash">Limpiar</vs-button>
        </div>

    </vs-sidebar>
</template>
<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import vSelect from 'vue-select';
export default {
    props: {
        isSidebarActive: {
            type: Boolean,
            required: true
        },
    },

    components: {
        VuePerfectScrollbar,
        'v-select': vSelect,
    },

    data () {
        return {
            settings                : { maxScrollbarLength: 60, wheelSpeed: .60},

            selectedProvincia       : null,
            selectedDistrito        : null,
            selectedUei             : null,
            selectedGestion         : null,
            selectedElabExpediente  : null,
            selectedModalidad       : null,
            selectedDirecta         : null,
            selectedContrato        : null,
            selectedOxi             : null,

            itemsProvincia          : [],
            itemsDistrito           : [],
            itemsUei                : [],
            itemsGestion            : [],
            itemsElabExpediente     : [],
            itemsModalidad          : [],
            itemsDirecta            : [],
            itemsContrato           : [],
            itemsOxi                : [],

        }
    },

    computed: {
        isSidebarActiveLocal: {
            get () {
                return this.isSidebarActive
            },
            set (val) {
                if (!val) {
                    this.$emit('closeSidebar');
                }
            }
        },

        scrollbarTag () { return this.$store.getters.scrollbarTag }
    },

    watch: {
        isSidebarActive (val) {
            if (!val) return
            this.initValues();
            this.$validator.reset();           
        },

        selectedProvincia(val){
            if(val.value === '') {
                this.selectedDistrito = null;
                this.itemsDistrito = [];
            } else {
                this.listarDistrito(val.value);
            }
        },
    },

    methods: {
        initValues () {
            this.listarProvincia();
            this.listarUei();
            this.listarEstadoGestion();
            this.listarEstadoElabExpediente();
            this.listarEstadoModalidad();
            this.listarEstadoAdminDirecta();
            this.listarEstadoContrata();
            this.listarEstadoOxi();
        },

        listarProvincia(){
            this.$vs.loading();
            this.$http.listarProvincia()
            .then(response => {
                this.$vs.loading.close();
                if(response.status === 200){
                    this.itemsProvincia = response.data;
                }
            })
            .catch(error => {
                this.$vs.loading.close();
                this.showMessageError(error.response.status, error.response.data.message);
            });
        },

        listarDistrito(id){
            this.$vs.loading();
            this.$http.listarDistritoPorProvincia(id)
            .then(response => {
                this.$vs.loading.close();
                if(response.status === 200){
                    this.itemsDistrito = response.data;
                }
            })
            .catch(error => {
                this.$vs.loading.close();
                this.showMessageError(error.response.status, error.response.data.message);
            });
        },

        listarUei(){
            console.log('ddd')
            this.$vs.loading();
            this.$http.fetchUei()
            .then(response => {
                this.$vs.loading.close();
                if(response.status === 200){
                    this.itemsUei = response.data;
                }
            })
            .catch(error => {
                this.$vs.loading.close();
                this.showMessageError(error.response.status, error.response.data.message);
            });
        },

        listarEstadoGestion(){
            this.$vs.loading();
            this.$http.fetchEstadoGestion()
            .then(response => {
                this.$vs.loading.close();
                if(response.status === 200){
                    this.itemsGestion = response.data;
                }
            })
            .catch(error => {
                this.$vs.loading.close();
                this.showMessageError(error.response.status, error.response.data.message);
            });
        },

        listarEstadoElabExpediente(){
            this.$vs.loading();
            this.$http.fetchEstadoElabExpediente()
            .then(response => {
                this.$vs.loading.close();
                if(response.status === 200){
                    this.itemsElabExpediente = response.data;
                }
            })
            .catch(error => {
                this.$vs.loading.close();
                this.showMessageError(error.response.status, error.response.data.message);
            });
        },

        listarEstadoModalidad(){
            this.$vs.loading();
            this.$http.fetchModalidad()
            .then(response => {
                this.$vs.loading.close();
                if(response.status === 200){
                    this.itemsModalidad = response.data;
                }
            })
            .catch(error => {
                this.$vs.loading.close();
                this.showMessageError(error.response.status, error.response.data.message);
            });
        },

        listarEstadoAdminDirecta(){
            this.$vs.loading();
            this.$http.fetchEstadoAdminDirecta()
            .then(response => {
                this.$vs.loading.close();
                if(response.status === 200){
                    this.itemsDirecta = response.data;
                }
            })
            .catch(error => {
                this.$vs.loading.close();
                this.showMessageError(error.response.status, error.response.data.message);
            });
        },

        listarEstadoContrata(){
            this.$vs.loading();
            this.$http.fetchEstadoContrata()
            .then(response => {
                this.$vs.loading.close();
                if(response.status === 200){
                    this.itemsContrato = response.data;
                }
            })
            .catch(error => {
                this.$vs.loading.close();
                this.showMessageError(error.response.status, error.response.data.message);
            });
        },

        listarEstadoOxi(){
            this.$vs.loading();
            this.$http.fetchEstadoOxi()
            .then(response => {
                this.$vs.loading.close();
                if(response.status === 200){
                    this.itemsOxi = response.data;
                }
            })
            .catch(error => {
                this.$vs.loading.close();
                this.showMessageError(error.response.status, error.response.data.message);
            });
        },

        aplicar(){
            this.isSidebarActiveLocal = false;
            const payload = {
                provincia   : this.selectedProvincia        !== null ? this.selectedProvincia.value         : null,
                distrito    : this.selectedDistrito         !== null ? this.selectedDistrito.value          : null,
                gestion     : this.selectedGestion          !== null ? this.selectedGestion.value           : null,
                expediente  : this.selectedElabExpediente   !== null ? this.selectedElabExpediente.value    : null,
                modalidad   : this.selectedModalidad        !== null ? this.selectedModalidad.value         : null,
                directa     : this.selectedDirecta          !== null ? this.selectedDirecta.value           : null,
                contrato    : this.selectedContrato         !== null ? this.selectedContrato.value          : null,
                oxi         : this.selectedOxi              !== null ? this.selectedOxi.value               : null,
                uei         : this.selectedUei              !== null ? { id: this.selectedUei.value, descripcion: this.selectedUei.label } : null,
            };

            this.$emit('execFilter', payload);
        },

        limpiar(){
            this.selectedProvincia          = null;
            this.selectedDistrito           = null;
            this.selectedUei                = null;
            this.selectedGestion            = null;
            this.selectedElabExpediente     = null;
            this.selectedModalidad          = null;
            this.selectedDirecta            = null;
            this.selectedContrato           = null;
            this.selectedOxi                = null;
        },

        showMessageAlert(message){
            this.$vs.notify({
                title: 'Aviso',
                text: message,
                position:'top-center',
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'danger'
            });
        },

        showMessageSuccess(message){
            this.$vs.notify({
                title: 'Información',
                text: message,
                position:'top-right',
                iconPack: 'feather',
                icon: 'icon-check',
                color: 'success'
            });
        },

        showMessageError(status, message){
            if(status === 400 || status === 409){
                this.$vs.notify({
                    title: 'Aviso',
                    text: message,
                    position:'top-center',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'warning'
                });
            }
            if(status === 401){
                this.$store.dispatch("logout").then(() => {
                    this.$router.push('/login').catch(() => {})
                });
            }
            if(status === 403){
                this.popupPaciente = false;
                this.popupEliminar = false;
                this.$vs.notify({
                    title: 'ACCESO DENEGADO',
                    text: 'No tiene permisos para esta proceso.',
                    position:'top-center',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            }
            if(status === 404){
                this.$vs.notify({
                    title: 'Aviso',
                    text: message,
                    position:'top-center',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'warning'
                });
            }
            if(status === 417){
                this.$vs.notify({
                    title: 'ALERTA',
                    text: message,
                    position:'top-center',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            }

            if(status === 500){
                this.$vs.notify({
                    title: 'ERROR',
                    text: 'Ups!!!. Ocurrio un error. Vuelve a intentarlo.',
                    position:'top-center',
                    iconPack: 'feather',
                    icon: 'icon-alert-triangle',
                    color: 'danger'
                });
            }
        },
    }

}
</script>
<style lang="scss" scoped>
.filter-project-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 550px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-filter-project {
    // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
    height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);

    &:not(.ps) {
      overflow-y: auto;
    }
}
</style>